import React, {Component} from 'react'
import * as acc from "accounting";

export default class Cennik extends Component {

    render() {
        return (<div style={{marginBottom: 10}}>
                <div className="row">
                    <div className="col-sm-12 text-center"
                         style={{fontWeight: 'bold', marginBottom: 10, marginTop: 10}}>
                        {this.props.item.idTrPrze === null ? <div className="cennikPrzystanek"><span
                                className='cennikMiejscowosc'>{this.props.item.nazMiOd}</span> {this.props.item.nazPrOd} - <span
                                className='cennikMiejscowosc'>{this.props.item.nazMiDo}</span> {this.props.item.nazPrDo}
                            </div>
                            : <div className="cennikPrzystanek"><span
                                className='cennikMiejscowosc'>{this.props.item.nazMiOd}</span> {this.props.item.nazPrOd} - <span
                                className='cennikMiejscowosc'>{this.props.item.nazMiPrze}</span> {this.props.item.nazPrPrzeOd}
                            </div>}</div>
                </div>
                <table id="tablePreview" className="table table-striped table-hover table-sm table-borderless"
                       style={{color: '#696969'}}>
                    <thead>
                    <tr>
                        <th width="10%">#</th>
                        <th width="15%">Rodzaj</th>
                        <th width="60%">Nazwa</th>
                        <th width="15%">Cena</th>
                    </tr>
                    </thead>

                    <tbody>
                    {this.props.biletyOne.map((item, index) => {
                        return <tr>
                            <td>
                                {index + 1}
                            </td>
                            <td>
                                {item.rodz}
                            </td>
                            <td>
                                {item.nazZniz}
                            </td>
                            <td>
                                {acc.formatMoney(item.cena, {
                                    symbol: "zł",
                                    format: "%v %s"
                                })}
                            </td>
                        </tr>
                    })}
                    </tbody>
                </table>
                {this.props.item.idTrPrze === null ? null :
                    <div>
                        <div className="row" style={{marginTop: 10}}>
                            <div className="col-sm-12 text-center cennikPrzystanek" style={{marginBottom: 10}}>
                                <span
                                    className='cennikMiejscowosc'>{this.props.item.nazMiPrze}</span> {this.props.item.nazPrPrzeDo} -
                                <span
                                    className='cennikMiejscowosc'>{this.props.item.nazMiDo}</span> {this.props.item.nazPrDo}
                            </div>
                        </div>
                        <table id="tablePreview" className="table table-striped table-hover table-sm table-borderless"
                               style={{color: '#696969'}}>
                            <thead>
                            <tr>
                                <th width="10%">#</th>
                                <th width="15%">Rodzaj</th>
                                <th width="60%">Nazwa</th>
                                <th width="15%">Cena</th>
                            </tr>
                            </thead>

                            <tbody>
                            {this.props.biletyTwo.map((item, index) => {
                                return <tr>
                                    <td>
                                        {index + 1}
                                    </td>
                                    <td>
                                        {item.rodz}
                                    </td>
                                    <td>
                                        {item.nazZniz}
                                    </td>
                                    <td>
                                        {acc.formatMoney(item.cena, {
                                            symbol: "zł",
                                            format: "%v %s"
                                        })}
                                    </td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/wyszukiwarkaComponents/szczegolyComponents/cennikComponents/Cennik.js